export default {
  direction: "rtl"
};
